import {Box, ResponsiveContext, Text} from "grommet";
import React from "react";
import { TextBasedIcon } from "../utils/styled";
import StatusIcon from "./StatusIcon";
import { ThemeContext } from "styled-components";
import { normalizeColor } from "grommet/utils";
import {
    faArrowRight as IconArrowRight
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "./FontAwesomeIcon";
import Button from "./Button";
import { snakeCase } from "../utils/string";

const StatusMessage = ({
    type,
    color: colorOverride,
    message,
    size,
    fontSize,
    apiError,
    heading,
    textProps={},
    textIcon,
    cta,
    condensed=false,
    headingSize="large",
    ...props
}) => {
    const status = apiError ? 'error' : type;
    let color;
    switch (status) {
    case 'ok':
        color = "status-ok";
        break;
    case 'info':
        color = "status-info";
        break;
    case 'warning':
        color = "status-warning-2";
        break;
    default:
        color = "status-critical";
    }
    if (colorOverride) color = colorOverride;

    return (
        <ThemeContext.Consumer>
            {(theme) => (
                <Box
                    align="center"
                    gap="small"
                    justify="between"
                    pad={apiError ? {vertical: 'xsmall', horizontal: 'small'} : (condensed ? {horizontal: 'small', vertical: 'xsmall'} : {vertical: size || 'small', horizontal: 'medium'})}
                    background={{
                        color,
                        opacity: theme.dark ? '0.2' : '0.1'
                    }}
                    round="xsmall"
                    margin={{vertical: 'small'}}
                    width={{max: '100%', min: 'small'}}
                    direction="row"
                    border={{color: `${normalizeColor(color, theme)}44`}}
                    height={{min: 'xxsmall'}}
                    {...props}
                >
                    <ResponsiveContext.Consumer>
                        {(size) => (
                            <Box align={condensed ? "start" : "center"} direction="row" gap="small" margin={{vertical: 'xsmall'}}>
                                <Box width={condensed ? {min: '18px', max: '18px'} : {min: '36px', max: '36px'}}>
                                    {textIcon ?
                                        (
                                            <Box width={{min: '25px'}}>
                                                <TextBasedIcon
                                                    text={textIcon}
                                                    color={color}
                                                    size="medium"
                                                    border={{
                                                        color,
                                                        size: 'small'
                                                    }}
                                                    highlight={{
                                                        color,
                                                        opacity: 0.1
                                                    }} />
                                            </Box>
                                        ) :
                                        (<StatusIcon type={status} {...condensed ? {size: "small"} : {}}/>)
                                    }
                                </Box>
                                <Box direction="column" gap="xxsmall">
                                    {heading && <Text size={headingSize} weight={600}>{heading}</Text>}
                                    {apiError?.message || message && (<Text {...(fontSize ? {size: fontSize} : {})} {...textProps}>{apiError ? apiError?.message: message}</Text>)}
                                </Box>
                            </Box>
                        )}
                    </ResponsiveContext.Consumer>
                    {cta ? (
                        <Button
                            event={{section: 'status_message', element: snakeCase(cta?.text), description: snakeCase(heading || apiError?.message || '')}}  
                            hoverIndicator={{dark: `${normalizeColor(color, theme)}11`, light: `${normalizeColor(color, theme)}22`}}
                            label={(
                                <Box direction="row" align="center" gap="xsmall">
                                    <Text color={cta?.textColor || color} weight={600}>{cta?.text}</Text>
                                    <FontAwesomeIcon size="small" SelectedIcon={IconArrowRight} color={cta?.textColor || color} />
                                </Box>
                            )}
                            onClick={cta.onClick}/>
                    ) : (<></>)}
                </Box>
            )}
        </ThemeContext.Consumer>
    );
};

export default StatusMessage;
